"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserWithAchievementsData = exports.UserWithAchievementsDataSchema = exports.isUserAchievementsData = exports.UserAchievementsDataSchema = exports.isUserEarnedAchievements = exports.isUserAchievement = void 0;
const zod_1 = require("zod");
const language_codes_types_1 = require("../language_codes_types");
const achievements_metadata_types_1 = require("./achievements_metadata_types");
const UserAchievementSchema = achievements_metadata_types_1.AchievementDefinitionSchema.pick({
    id: true,
}).extend({
    timestamp: zod_1.z.number(),
});
const isUserAchievement = (v) => UserAchievementSchema.safeParse(v).success;
exports.isUserAchievement = isUserAchievement;
const UserEarnedAchievementsSchema = zod_1.z.object({
    achievements: zod_1.z.array(UserAchievementSchema),
    userId: zod_1.z.string(),
});
const isUserEarnedAchievements = (v) => UserEarnedAchievementsSchema.safeParse(v).success;
exports.isUserEarnedAchievements = isUserEarnedAchievements;
const LanguagesAchievementsSchema = zod_1.z.object(language_codes_types_1.languagePairCodes.reduce((acc, languagePairCode) => ({
    ...acc,
    [languagePairCode]: zod_1.z.array(UserAchievementSchema).optional(),
}), {}));
exports.UserAchievementsDataSchema = zod_1.z.object({
    accountAchievements: zod_1.z.array(UserAchievementSchema).optional(),
    languageAchievements: LanguagesAchievementsSchema.optional(),
});
const isUserAchievementsData = (v) => exports.UserAchievementsDataSchema.safeParse(v).success;
exports.isUserAchievementsData = isUserAchievementsData;
exports.UserWithAchievementsDataSchema = exports.UserAchievementsDataSchema.extend({
    userId: zod_1.z.string(),
});
const isUserWithAchievementsData = (v) => exports.UserWithAchievementsDataSchema.safeParse(v).success;
exports.isUserWithAchievementsData = isUserWithAchievementsData;
//# sourceMappingURL=user_achievements_types.js.map